var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOkCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.387,
    height: 57.335,
    viewBox: "0 0 60.387 57.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#58ab27;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.967,10.626l-.02.028-1.4,1.955L25.69,61.3a3.334,3.334,0,0,1-2.533,1.388c-.059,0-.118,0-.177,0a3.33,3.33,0,0,1-2.489-1.117L3.8,42.824c-.048-.054-.095-.109-.139-.166A6.748,6.748,0,0,1,4.478,33.4l4.37,5.033c.015.009.018.033.044.078L22.7,54.025,56.547,6.746a3.333,3.333,0,1,1,5.42,3.88Z",
    transform: "translate(-2.202 -5.354)",
    fill: "#58ab27"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkCheckIcon);
export default __webpack_public_path__ + "static/media/ok-check-icon.6131c809.svg";
export { ForwardRef as ReactComponent };